import styled from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;

    & > ul > li {
        font-size: 14px;
    }

    @media screen and (min-width: 769px) {
        width: 360px;
    }
`;

export const Headaer = styled.div`
    display: flex;
    width: 100%;
`;

export const BackArrow = styled.div`
    display: flex;
    flex: 1;
`;

export const Download = styled.div`
    display: flex;
    flex: 1;
    justify-content: flex-end;
`;
